import React from 'react';

const DeviceObjectSummary = ({
  device,
  device: {
    friendlyName,
    serialNumber,
    modelCode,
    isSubscriberOwned,
    activationStatus,
    deviceStatus,
    lob,
  },
}) => (
  <div>
    {friendlyName && <p>{`"${friendlyName}"`}</p>}
    {serialNumber && <p>{`Serial #: ${serialNumber}`}</p>}
    {modelCode && lob !== 'video' && <p>{`Model: ${modelCode}`}</p>}
    {isSubscriberOwned && (
      <p>
        <span className="status status--warning">
          Purchased equipment is not eligible for return
        </span>
      </p>
    )}
    {(activationStatus === 'DISCONNECTED' || deviceStatus === 'INACTIVE') && (
      <p>
        <span className="status">
          Inactive
        </span>
      </p>
    )}
  </div>
);


export default DeviceObjectSummary;
